export default function pxToVw(px) {
  // return (100 * px) / 1200;
  return px
}



// WEBPACK FOOTER //
// ./src/Helper/pxToVw.js